export default {
    /*PROD*/
    URL_PORTAL: 'https://10.150.27.129:8281/portal/',
    secretKey: '3864c3a6-2f33-4a8d-99f7-445e106262fe',
    clientID: '8982f9a8-975c-4d80-8025-fca6bb4232c9'
}


// WEBPACK FOOTER //
// ./src/util/configuracao.js